var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{class:[ _vm.backgroundClass, 'app-avatar', _vm.sizeClass ],attrs:{"size":_vm.small ? 25 : 40}},[_vm._v(" "+_vm._s(_vm.initials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }